import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { Column, Row } from 'web-ui-components/lib/global/layout';
import { DataManagementShell } from 'web-ui-components/lib/layout/shells';
import { UtilityNav } from 'web-ui-components/lib/navigation/site-navs';
import { Grid } from 'web-ui-components/lib/layout/grids';

import { getBrandId } from '../../../infrastructure/config/selectors';

const CommonShell = ({ backClick, brandID, children }) => {
  if (brandID === 'VM') {
    return (
      <DataManagementShell
        header={<div />}
        utilityNavigation={<UtilityNav leftContent={<BackButton onClick={backClick} />} />}
      >
        <Card>
          <Grid.TwoThirds>{children}</Grid.TwoThirds>
        </Card>
      </DataManagementShell>
    );
  }
  return (
    <Column>
      <div className="u-margin-left-4">
        <BackButton onClick={backClick} />
      </div>
      <Row className="u-padding-x-2">
        <Column md={12} mdOffset={6}>
          <Card bordered="unbranded">{children}</Card>
        </Column>
      </Row>
    </Column>
  );
};

CommonShell.propTypes = {
  brandID: PropTypes.string.isRequired,
  backClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

const mapStateToProps = ({ config }) => ({ brandID: getBrandId(config) });

const ConnectedCommonShell = connect(mapStateToProps)(CommonShell);

export { ConnectedCommonShell as CommonShell };
